import * as React from "react";
import { Checkbox } from "antdv5";
import { FunctionBar as FunctionBarStyled } from "../../../styles/DeviceList";
import ClubOpts from "../../common/ClubOpts";
import {
  PlusOutlined,
  CheckOutlined,
  CloseOutlined,
  PrinterOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { color } from "../../../styles/color";
import type { SetState, Fn } from "../../../client_types";

interface IAddItem {
  DeviceUUID: string;
  DeviceName: string;
}

interface IProps {
  show: boolean;
  checked: boolean;
  mutipleShow: boolean;
  fileDetail: boolean;
  addItem: IAddItem;
  setShow: SetState<boolean>;
  setMutipleShow: SetState<boolean>;
  setAddItem: SetState<IAddItem>;
  removeAll: Fn;
  addDevice: Fn;
  handleEnter: (e: React.KeyboardEvent, fn: Fn) => void;
  updateDevice: Fn;
  uploadData: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checkChange: (e: React.MouseEvent<HTMLElement>) => void;
  handleUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: Fn;
  clubList: any[] | null;
}

const FunctionBar = ({
  show,
  checked,
  mutipleShow,
  removeAll,
  setShow,
  setMutipleShow,
  setAddItem,
  addItem,
  addDevice,
  handleEnter,
  updateDevice,
  uploadData,
  checkChange,
  handleUpload,
  fileDetail,
  handleSubmit,
  clubList,
}: IProps) => (
  <FunctionBarStyled show={show} mutipleShow={mutipleShow}>
    <div className="box">
      {!show ? (
        <>
          <button className="delBtn btn" onClick={removeAll}>
            <DeleteOutlined /> 删除勾选
          </button>
          <button className="btn" onClick={() => setShow(!show)}>
            <PlusOutlined /> 新增
          </button>
          <button className="btn cancelBtn" onClick={() => window.print()}>
            <PrinterOutlined /> 打印列表
          </button>
        </>
      ) : null}
      {show ? (
        <>
          <div className="addInfo">
            <label className="labelTag" htmlFor="deviceName">
              踏板名称
              <input
                type="text"
                id="deviceName"
                name="deviceName"
                onChange={(e) =>
                  setAddItem({ ...addItem, DeviceName: e.target.value })
                }
                value={addItem.DeviceName}
                onKeyPress={(e) => handleEnter(e, updateDevice)}
              />
            </label>
            <label className="labelTag" htmlFor="uuid">
              踏板ID
              <input
                type="text"
                id="uuid"
                name="uuid"
                onChange={(e) =>
                  setAddItem({ ...addItem, DeviceUUID: e.target.value })
                }
                value={addItem.DeviceUUID}
              />
            </label>
            <div className="btnGroup">
              <button className="btn" onClick={addDevice}>
                <CheckOutlined /> 确定
              </button>
              <button className="cancelBtn btn" onClick={() => setShow(false)}>
                <CloseOutlined /> 取消
              </button>
            </div>
          </div>
          <div
            className="btn addBtn"
            onClick={() => {
              setMutipleShow(true);
            }}
          >
            <CloudUploadOutlined /> 批量新增
          </div>
          <div className="mask"></div>
          <div className="uploadBox">
            <Checkbox
              onClick={(e) => checkChange(e)}
              checked={checked ? true : false}
              style={{
                color: `${color.markedSecondary}`,
                marginBottom: "1rem",
              }}
            >
              保留旧有踏板
            </Checkbox>
            <div className="uploadBtn btn">
              <CloudUploadOutlined />{" "}
              {uploadData ? uploadData.name : "选择档案"}
              <input
                type="file"
                accept=".xlsx,.xls"
                id="upload"
                name="upload"
                onClick={(e) => ((e.target as HTMLInputElement).value = "")}
                onChange={(e) => handleUpload(e)}
                style={{
                  opacity: 0,
                  position: "absolute",
                  left: "0",
                  top: "0",
                  width: "100%",
                }}
              />
            </div>
            <div className="btnGroup">
              <button
                className="btn"
                disabled={!fileDetail}
                onClick={handleSubmit}
              >
                上传
              </button>
              <button
                className="btn cancelBtn"
                onClick={() => setMutipleShow(false)}
              >
                取消
              </button>
            </div>
          </div>
        </>
      ) : null}
    </div>
    <ClubOpts clubList={clubList} />
  </FunctionBarStyled>
);

export default FunctionBar;
